import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import { Questionnaire, QuestionnaireDefinition } from "../common/models";
import { QuestionnaireTaskView } from "../common/QuestionnaireTaskView";


const Definition: QuestionnaireDefinition = {
  name: 'Custom Affect Scale',
  key: 'customAffectScaleQuestionnaire',
  cohort: 'mood',
  title: 'Custom Affect Scale',
  description: '',
  type: 'questionnaire',
  estimatedCompletionTime: '1:30',
  groups: [
    {
      key: 'CustomAffectScale',
      // Note: We need to display multiple lines in the description.
      content:
      <>
        <Typography>Thinking about yourself and how you normally feel, to what extent do you generally feel?</Typography>
        <Typography>0=Not at all, 10=Extremely</Typography>
      </>
      ,
      questions: [
        {
          // The key is from REDCap.
          key: 'sadOrDown',
          type: 'multiple-choice',
          question: 'Sad or down',
          options: [
            { key: '0', displayName: '0' },
            { key: '1', displayName: '1' },
            { key: '2', displayName: '2' },
            { key: '3', displayName: '3' },
            { key: '4', displayName: '4' },
            { key: '5', displayName: '5' },
            { key: '6', displayName: '6' },
            { key: '7', displayName: '7' },
            { key: '8', displayName: '8' },
            { key: '9', displayName: '9' },
            { key: '10', displayName: '10' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'joyful',
          type: 'multiple-choice',
          question: 'Joyful',
          options: [
            { key: '0', displayName: '0' },
            { key: '1', displayName: '1' },
            { key: '2', displayName: '2' },
            { key: '3', displayName: '3' },
            { key: '4', displayName: '4' },
            { key: '5', displayName: '5' },
            { key: '6', displayName: '6' },
            { key: '7', displayName: '7' },
            { key: '8', displayName: '8' },
            { key: '9', displayName: '9' },
            { key: '10', displayName: '10' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'motivated',
          type: 'multiple-choice',
          question: 'Motivated or interested',
          options: [
            { key: '0', displayName: '0' },
            { key: '1', displayName: '1' },
            { key: '2', displayName: '2' },
            { key: '3', displayName: '3' },
            { key: '4', displayName: '4' },
            { key: '5', displayName: '5' },
            { key: '6', displayName: '6' },
            { key: '7', displayName: '7' },
            { key: '8', displayName: '8' },
            { key: '9', displayName: '9' },
            { key: '10', displayName: '10' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'lackOfPleasure',
          type: 'multiple-choice',
          question: 'Lack of pleasure (in things you tend to enjoy)',
          options: [
            { key: '0', displayName: '0' },
            { key: '1', displayName: '1' },
            { key: '2', displayName: '2' },
            { key: '3', displayName: '3' },
            { key: '4', displayName: '4' },
            { key: '5', displayName: '5' },
            { key: '6', displayName: '6' },
            { key: '7', displayName: '7' },
            { key: '8', displayName: '8' },
            { key: '9', displayName: '9' },
            { key: '10', displayName: '10' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'tired',
          type: 'multiple-choice',
          question: 'Tired or fatigued',
          options: [
            { key: '0', displayName: '0' },
            { key: '1', displayName: '1' },
            { key: '2', displayName: '2' },
            { key: '3', displayName: '3' },
            { key: '4', displayName: '4' },
            { key: '5', displayName: '5' },
            { key: '6', displayName: '6' },
            { key: '7', displayName: '7' },
            { key: '8', displayName: '8' },
            { key: '9', displayName: '9' },
            { key: '10', displayName: '10' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'energetic',
          type: 'multiple-choice',
          question: 'Energetic',
          options: [
            { key: '0', displayName: '0' },
            { key: '1', displayName: '1' },
            { key: '2', displayName: '2' },
            { key: '3', displayName: '3' },
            { key: '4', displayName: '4' },
            { key: '5', displayName: '5' },
            { key: '6', displayName: '6' },
            { key: '7', displayName: '7' },
            { key: '8', displayName: '8' },
            { key: '9', displayName: '9' },
            { key: '10', displayName: '10' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'agitated',
          type: 'multiple-choice',
          question: 'Agitated (restless, fidgety, pacing, cannot sit still)',
          options: [
            { key: '0', displayName: '0' },
            { key: '1', displayName: '1' },
            { key: '2', displayName: '2' },
            { key: '3', displayName: '3' },
            { key: '4', displayName: '4' },
            { key: '5', displayName: '5' },
            { key: '6', displayName: '6' },
            { key: '7', displayName: '7' },
            { key: '8', displayName: '8' },
            { key: '9', displayName: '9' },
            { key: '10', displayName: '10' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'irritated',
          type: 'multiple-choice',
          question: 'Irritated or angry (towards something or someone)',
          options: [
            { key: '0', displayName: '0' },
            { key: '1', displayName: '1' },
            { key: '2', displayName: '2' },
            { key: '3', displayName: '3' },
            { key: '4', displayName: '4' },
            { key: '5', displayName: '5' },
            { key: '6', displayName: '6' },
            { key: '7', displayName: '7' },
            { key: '8', displayName: '8' },
            { key: '9', displayName: '9' },
            { key: '10', displayName: '10' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'lonely',
          type: 'multiple-choice',
          question: 'Lonely or isolated',
          options: [
            { key: '0', displayName: '0' },
            { key: '1', displayName: '1' },
            { key: '2', displayName: '2' },
            { key: '3', displayName: '3' },
            { key: '4', displayName: '4' },
            { key: '5', displayName: '5' },
            { key: '6', displayName: '6' },
            { key: '7', displayName: '7' },
            { key: '8', displayName: '8' },
            { key: '9', displayName: '9' },
            { key: '10', displayName: '10' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'concentrated',
          type: 'multiple-choice',
          question: 'Concentrated (not distracted or inattentive)',
          options: [
            { key: '0', displayName: '0' },
            { key: '1', displayName: '1' },
            { key: '2', displayName: '2' },
            { key: '3', displayName: '3' },
            { key: '4', displayName: '4' },
            { key: '5', displayName: '5' },
            { key: '6', displayName: '6' },
            { key: '7', displayName: '7' },
            { key: '8', displayName: '8' },
            { key: '9', displayName: '9' },
            { key: '10', displayName: '10' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'relaxed',
          type: 'multiple-choice',
          question: 'Relaxed or calm',
          options: [
            { key: '0', displayName: '0' },
            { key: '1', displayName: '1' },
            { key: '2', displayName: '2' },
            { key: '3', displayName: '3' },
            { key: '4', displayName: '4' },
            { key: '5', displayName: '5' },
            { key: '6', displayName: '6' },
            { key: '7', displayName: '7' },
            { key: '8', displayName: '8' },
            { key: '9', displayName: '9' },
            { key: '10', displayName: '10' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'worried',
          type: 'multiple-choice',
          question: 'Worried or anxious',
          options: [
            { key: '0', displayName: '0' },
            { key: '1', displayName: '1' },
            { key: '2', displayName: '2' },
            { key: '3', displayName: '3' },
            { key: '4', displayName: '4' },
            { key: '5', displayName: '5' },
            { key: '6', displayName: '6' },
            { key: '7', displayName: '7' },
            { key: '8', displayName: '8' },
            { key: '9', displayName: '9' },
            { key: '10', displayName: '10' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'desireToEscape',
          type: 'multiple-choice',
          question: 'Desire to escape (your thoughts and/or feelings)',
          options: [
            { key: '0', displayName: '0' },
            { key: '1', displayName: '1' },
            { key: '2', displayName: '2' },
            { key: '3', displayName: '3' },
            { key: '4', displayName: '4' },
            { key: '5', displayName: '5' },
            { key: '6', displayName: '6' },
            { key: '7', displayName: '7' },
            { key: '8', displayName: '8' },
            { key: '9', displayName: '9' },
            { key: '10', displayName: '10' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        }
      ]
    }
  ]
};
export const CustomAffectScaleDefinition = Definition;

export const CustomAffectScale = ({onCompletion}: {onCompletion: () => void}) => {
  const [questionnaire, setQuestionnaire] = useState<Questionnaire>(() => ({
    id: 'customAffectScaleQuestionnaires',
    ...Definition,
    startedAt: new Date().toISOString(),
    completedAt: null,
    status: 'in-progress',
  }));

  console.log('CustomAffectScale component rendered', questionnaire);

  const handleOnCompletion = () => {
    console.log('CustomAffectScale completed');

    onCompletion();
  };

  const handleOnChange = (questionnaire: Questionnaire) => {
    console.log('questionnaire', questionnaire);
    setQuestionnaire(questionnaire);
  }

  console.log('CustomAffectScale component rendered', questionnaire);

  return (
    <div>
      <QuestionnaireTaskView questionnaire={questionnaire} onChange={handleOnChange} onCompletion={handleOnCompletion  } />
    </div>
  );
}
